import GenericView from 'js/views/generic.view';
import AppUserCollection from 'js/models/profile.appuseraction.collection';
import Template from 'js/templates/profile.appuseraction.hbs';
import {el, tagName, template} from "../adapters/backbone-decorators";

require('jqueryUI');

@el("#display-app-user-action")
@tagName('span')
@template(Template)
class ProfileAppuserActionView extends GenericView {

    constructor() {
        super();
        this.appUserCollection = new AppUserCollection();
        this.appUserCollection.bind("sync", this.renderCollection, this);
        this.loadAppUserCollection();
        console.info("initialize AppUserCollection");
    }

    render() {
        super.render();
    }

    renderCollection() {
        var tempTemplate = this.template({appuseraction: this.appUserCollection.toJSON()});
        this.$el.html(tempTemplate);
        this.$('[data-i18n]').i18n();
    }

    loadAppUserCollection() {
        this.appUserCollection.fetch();
        console.info("Fetching bundles");
    }
}

export default ProfileAppuserActionView;
